import { createContext } from 'react';
import { Quote } from '@src/@types/quotes';

export const QuoteContext = createContext<{
  quote: Quote;
  setQuote: React.Dispatch<React.SetStateAction<Quote>>;
}>({ quote: {} as Quote, setQuote: () => null } as {
  quote: Quote;
  setQuote: React.Dispatch<React.SetStateAction<Quote>>;
});
